import { Box, FlexBox, Icon, Text, Tooltip } from '@dixa/lib-shared-habla';

import style from './style.module.scss';

const tooltipText =
  'The default language will be shown, if the users language can’t be detected or not a part of the activated languages. Only one language can be chosen as the default. ';

export function FirstRow() {
  return (
    <FlexBox
      alignItems="center"
      justifyContent="space-between"
      className={style.root}
    >
      <Box>
        <Text.Paragraph variant="3" color="secondary">
          Activate Languages
        </Text.Paragraph>
      </Box>

      <FlexBox alignItems="center" gap="200">
        <Text.Paragraph variant="3" color="secondary">
          Default
        </Text.Paragraph>{' '}
        <Tooltip requireClick={true} content={tooltipText}>
          <Icon
            name="info"
            size={16}
            style={{ cursor: 'pointer', display: 'block' }}
          />
        </Tooltip>
      </FlexBox>
    </FlexBox>
  );
}
